"use strict";

export default function especialidadesUnidades() {
    document.addEventListener("DOMContentLoaded", () => {
        const section = document.querySelector(".o-especialidades");
        if (!section) return;

        const buttons = Array.from(
            section.querySelectorAll(".o-especialidades__unit"),
        );
        if (!buttons.length) return;

        const descWrap = section.querySelector(".o-especialidades__unit-desc");
        const descTextEl =
            descWrap?.querySelector(".o-especialidades__unit-desc-text") ||
            null;

        // Se não existir área de descrição, não tem o que trocar
        if (!descTextEl) return;

        const setActive = (btn) => {
            // ativa visualmente
            buttons.forEach((b) => b.classList.remove("is-active"));
            btn.classList.add("is-active");

            // acessibilidade básica (opcional)
            buttons.forEach((b) => b.setAttribute("aria-pressed", "false"));
            btn.setAttribute("aria-pressed", "true");

            // troca o texto
            const newDesc = (btn.dataset.desc || "").trim();
            if (newDesc) {
                descTextEl.textContent = newDesc;
            }
        };

        // Estado inicial: tenta achar um botão que tenha desc igual ao texto atual.
        // Se não achar, ativa o primeiro com data-desc preenchido.
        const current = (descTextEl.textContent || "").trim();
        const match = buttons.find(
            (b) => (b.dataset.desc || "").trim() === current,
        );
        const firstWithDesc = buttons.find(
            (b) => (b.dataset.desc || "").trim().length > 0,
        );

        setActive(match || firstWithDesc || buttons[0]);

        // Clique
        buttons.forEach((btn) => {
            // se não tiver link real, evita navegação
            const href = (btn.getAttribute("href") || "").trim();
            const isVoidLink =
                !href ||
                href === "#" ||
                href === "javascript:void(0)" ||
                href === "javascript:void(0);";

            btn.addEventListener("click", (e) => {
                // Se você quer SEMPRE trocar o endereço e não navegar,
                // troque essa condição por: e.preventDefault();
                if (isVoidLink) e.preventDefault();

                setActive(btn);
            });
        });
    });
}
